import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Table from 'rsuite/Table'
import Pagination from 'rsuite/Pagination'
import {isEmpty} from 'lodash'
import {StateParamsModel} from 'src/app/modules/common/Model'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as fixedDepositLeadsRedux from '../redux'

const FixedDepositLeadsReport = () => {
  const dispatch = useDispatch()
  const {
    data: {data: leads, total},
    loading,
  } = useSelector((state: any) => state.fixedDepositLeadsReport)

  const [params, setParams] = useState<StateParamsModel>({page: 1, limit: 15})

  useEffect(() => {
    dispatch(fixedDepositLeadsRedux.actions.getFixedDepositLeads(params))
  }, [params])

  const Cell = Table.Cell

  const columns = [
    {label: 'S.N.', dataKey: 'sn', width: 60, cell: <Cell dataKey='sn' />},
    {
      label: 'Full Name',
      dataKey: 'full_name',
      flexGrow: 1,
      cell: <Cell>{(rowData: any) => rowData.full_name || '-'}</Cell>,
    },
    {
      label: 'Mobile',
      dataKey: 'mobile_number',
      width: 150,
      cell: <Cell>{(rowData: any) => rowData.mobile_number || '-'}</Cell>,
    },
    {
      label: 'Email',
      dataKey: 'email_address',
      flexGrow: 1,
      cell: <Cell>{(rowData: any) => rowData.email_address || '-'}</Cell>,
    },
    {
      label: 'Submitted At',
      dataKey: 'created_at',
      width: 180,
      cell: <Cell>{(rowData: any) => rowData.created_at || '-'}</Cell>,
    },
  ]

  const tableData = !isEmpty(leads)
    ? leads.map((item: any, i: number) => ({
        sn: (params.page - 1) * params.limit + (i + 1),
        full_name: item.full_name,
        mobile_number: item.mobile_number,
        email_address: item.email_address,
        created_at: item.created_at,
      }))
    : []

  const handleRefresh = () => {
    dispatch(fixedDepositLeadsRedux.actions.getFixedDepositLeads(params))
  }

  return (
    <div className='shadow p-3 bg-white rounded'>
      <DesignComponent
        moduleName='Fixed Deposit Leads'
        params={params}
        setParams={setParams}
        handleRefresh={handleRefresh}
        addShow={false}
        deleteShow={false}
        importShow={false}
        exportShow={false}
        toggleMultipleShow={false}
        loading={loading}
      />

      <div className='datatable'>
        <RSuiteTable
          onChecked={() => {}}
          showCheckbox={false}
          columns={columns}
          showLoading={loading}
          data={tableData}
          checkedValues={[]}
        />
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          className='mt-5'
          maxButtons={5}
          size='sm'
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={total || 0}
          limitOptions={[10, 20, 50]}
          limit={params.limit}
          activePage={params.page}
          onChangePage={(value) => setParams({...params, page: value})}
          onChangeLimit={(value) => setParams({...params, limit: value})}
        />
      </div>
    </div>
  )
}

export default FixedDepositLeadsReport
